import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    standalone: false
})
export class DateComponent {
	@Input() date: string;
	@Input() isShort = true;
}
